import { useNavigate } from 'react-router-dom';
import { useMyApplication } from '../../features/customer-application/api';
import './apply.scss';

// Shown after submit (and whenever an applicant with a pending application logs
// in). Ordering is locked until a DeFeo admin approves the account.
export default function ApplyStatusPage() {
  const navigate = useNavigate();
  const { data, isLoading } = useMyApplication(true);
  const app = data?.application;

  if (isLoading) return null;

  if (!app) {
    return (
      <div className="apply-wiz">
        <div className="apply-card">
          <h2>No application found</h2>
          <p className="apply-help">You haven't started an application yet.</p>
        </div>
      </div>
    );
  }

  const approved = (app.customerStatus ?? app.status) === 'APPROVED';
  const needsInfo = app.status === 'NEEDS_INFO';
  const steps = ['Submitted', 'In review', approved ? 'Approved' : 'Decision', 'Start ordering'];
  const currentIdx = approved ? 2 : 1;

  return (
    <div className="apply-wiz">
      <div className="apply-card">
        <span className="apply-eyebrow">Your application</span>
        <h2>{app.legalName}</h2>
        {needsInfo ? (
          <div className="apply-banner apply-banner--warn">
            <b>Your rep needs more information.</b>
            {app.needsInfoMessage ? (
              <p style={{ margin: '4px 0 0' }}>{app.needsInfoMessage}</p>
            ) : null}
            <p style={{ margin: '8px 0 0' }}>
              <button className="apply-btn apply-btn--primary" onClick={() => navigate('/apply')}>
                Update my application
              </button>
            </p>
          </div>
        ) : approved ? (
          <div className="apply-banner apply-banner--ok">
            <b>You're approved.</b> Your account is active and you can place orders.
          </div>
        ) : (
          <p className="apply-help" style={{ margin: 0 }}>
            Thanks{app.ownerFirstName ? `, ${app.ownerFirstName}` : ''}. Your BMP account is set up
            and our team is reviewing your application. We'll email {app.ownerEmail} when there's a
            decision.
          </p>
        )}

        <div className="apply-statusbox">
          <span className="apply-eyebrow">Account status</span>
          <div className="apply-steps-mini">
            {steps.map((s, i) => (
              <span key={s} className={i === currentIdx ? 'on' : ''}>
                {i > 0 && ' › '}
                {s}
              </span>
            ))}
          </div>
          <div className="apply-muted">
            {approved
              ? 'Ordering is unlocked.'
              : 'Ordering unlocks once your rep approves the account and assigns your products and pricing.'}
          </div>
        </div>
      </div>
    </div>
  );
}
